import { Help } from '@carbon/icons-react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { Button } from '@/ui';
import { useHelp } from '../shell/HelpContext';
import { LanguageSwitch } from '../shell/LanguageSwitch';
import { Logo } from '../shell/Logo';
import s from './Layout.module.css';

/** Публичный макет: вход, второй фактор, приглашения (разделы area='public'). */
export function PublicLayout() {
  const { t } = useTranslation('shell');
  const help = useHelp();
  return (
    <div className={s.public}>
      <a className={s.skipLink} href="#main">
        {t('skipToContent')}
      </a>
      <header className={s.publicHeader}>
        <Logo />
        <div className={s.topBarGroup}>
          <Button variant="ghost" icon={Help} onClick={() => help.open()} aria-label={t('help.button')}>
            <span className={s.helpButtonLabel}>{t('help.button')}</span>
          </Button>
          <LanguageSwitch />
        </div>
      </header>
      <main id="main" className={s.publicMain} tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
}
